// @flow
export { default } from './QuoteToc';



// WEBPACK FOOTER //
// ./src/components/quote/QuoteToc/index.js